// if (typeof card_data !== "undefined" && card_data) {
// 	const filters = {
// 		all(todos) {
// 			return todos;
// 		},
// 		principal(todos) {
// 			return todos.filter((todo) => {
// 				return todo.Principal;
// 			});
// 		},
// 		// completed(todos) {
// 		// 	return todos.filter(function (todo) {
// 		// 		return todo.completed;
// 		// 	});
// 		// },
// 	};

// 	createApp({
// 		// todos: todoStorage.fetch(),
// 		gridItems: card_data.sort(function () {
// 			return 0.5 - Math.random();
// 		}),
// 		gridType: card_adddata,
// 		filteredSet: "",
// 		filteredSetLoc: "",
// 		shownrecords: 21,
// 		bottom: false,

// 		get filteredTodos() {
// 			let subData = this.gridItems;
// 			if (this.groupShown === "associates") {
// 				subData = subData.filter((gI) => {
// 					return gI.Principal === "True";
// 				});
// 			} else {
// 				subData = subData.filter((gI) => {
// 					return gI.Principal !== "True";
// 				});
// 			}
// 			if (this.filter_loc && this.filter_loc !== "All") {
// 				subData = subData.filter((gI) => {
// 					return gI.Location === this.filter_loc;
// 				});
// 			}
// 			return subData;
// 			// return this.gridItems;
// 		},

// 		get principals() {
// 			// return this.todos.length;
// 			return filters.principal(this.gridItems).length;
// 		},

// 		get allDone() {
// 			return this.principals === 0;
// 		},

// 		set allDone(value) {
// 			// this.todos.forEach(function (todo) {
// 			// 	todo.completed = value;
// 			// });
// 		},

// 		save() {
// 			todoStorage.save(this.gridItems);
// 		},

// 		removeTodo(todo) {
// 			this.gridItems.splice(this.gridItems.indexOf(todo), 1);
// 		},

// 		editTodo(todo) {
// 			this.beforeEditCache = todo.title;
// 			this.editedTodo = todo;
// 		},

// 		pluralize(n) {
// 			return n === 1 ? "item" : "items";
// 		},
// 	}).mount("#filter_people");
// } else {
// 	// Static for style guide
// 	$(".filter-button").on("click", function (e) {
// 		// e.preventDefault();
// 		$(this).closest(".filters").toggleClass("filters-on");
// 	});
// }

// if ($(".doVue").hasClass("doVue")) {
// 	const filterGrid = new Vue({
// 		el: "#filterGrid",
// 		data: {
// 			modal: {
// 				on: false,
// 				type: "",
// 			},
// 		},
// 	});
// }

/*
Vue.component("dln-cards", {
	data: function () {
		return {
			cardData: null,
			filteredSet: "",
			filteredSetLoc: "",
			shownrecords: 21,
			bottom: false,
		};
	},
	mounted() {
		let scopeThis = this;
		if (typeof card_data !== "undefined") {
			if (window.location.pathname.indexOf("member-benefits") > -1) {
				this.filteredSet = "Design Stimulus";
			}
			this.cardData = card_data.sort(function () {
				return 0.5 - Math.random();
			});
			// this.cardData = card_data;
			// this.cardData = _.shuffle(card_data);
			// this.cardData = card_data;
			if (typeof card_adddata !== "undefined") {
				if (card_adddata === "data-guide") {
					this.loadMoreGuide(2);
				}
			}

			var urlParams = new URLSearchParams(window.location.search);

			if (urlParams.has("category_guide")) {
				this.filteredSet = urlParams.get("category_guide");
			}
			if (urlParams.has("category_location")) {
				this.filteredSetLoc = urlParams.get("category_location");
			}

			window.addEventListener("scroll", () => {
				this.bottom = this.bottomVisible();
			});
		}
	},
	computed: {
		shownSubset: function () {
			if (!this.cardData) {
				return null;
			}

			if (
				this.shownrecords < this.cardData.length &&
				this.cardData.length > 0 &&
				this.filteredSet === "" &&
				this.filteredSetLoc === ""
			) {
				return this.cardData.slice().splice(0, this.shownrecords);
			} else {
				return this.cardData;
			}
		},
	},
	methods: {
		loadMoreGuide(whatPage) {
			var sThis = this;
			var startpage = whatPage;
			var addQuery = "/?get=data-guide&data-page=" + startpage;
			$.get(addQuery, function (data) {
				// console.log(data);
				if (data.length > 0) {
					sThis.cardData = sThis.cardData.concat(data);
					// console.log(sThis.cardData);
					var newPage = startpage + 1;
					sThis.loadMoreGuide(newPage);
				}
			});
		},
		bottomVisible() {
			const scrollY = window.scrollY;
			const visible = document.documentElement.clientHeight;
			const pageHeight = document.documentElement.scrollHeight;
			const bottomOfPage = visible + scrollY + visible >= pageHeight;
			return bottomOfPage || pageHeight < visible;
		},
	},
	watch: {
		bottom(bottom) {
			if (bottom) {
				if (this.cardData.length > this.shownrecords) {
					let tempShown = this.shownrecords + 20;
					if (tempShown > this.cardData.length) {
						tempShown = this.cardData.length;
					}
					this.shownrecords = tempShown;
				}
			}
		},
	},
});

*/

// window.addEventListener('load', function () {
const dlnapp = new Vue({
	el: "#app",
	data: {
		modal: {
			on: false,
			type: "",
		},
	},
	computed: {
		modalTF() {
			return this.modal.on;
		},
	},
	mounted() {
		let appScope = this;
		if (window.location.search === "?theme=dln2022") {
			setTimeout(function () {
				$("a").each(function () {
					if (
						$(this).attr("href") &&
						$(this).attr("href").length > 3 &&
						!$(this).attr("href").includes("theme=dln2022")
					) {
						$(this).attr(
							"href",
							$(this).attr("href") + "?theme=dln2022"
						);
					}
				});
			});
		}

		$(".launch-modal-action").on("click", function (e) {
			e.preventDefault();
			appScope.launchModal("login");
		});

		$(".show-subnav").on("click", function (e) {
			e.preventDefault();
			var subTarget = $(this).data("subnav");
			if ($("." + subTarget + "-subnav").hasClass("subnav-active")) {
				$("." + subTarget + "-subnav").removeClass("subnav-active");
			} else {
				$(".subnav-active").removeClass("subnav-active");
				$("." + subTarget + "-subnav").addClass("subnav-active");
			}
			return false;
		});
	},
	watch: {
		modalTF() {
			if (this.modal.on === true) {
				jQuery("body").addClass("modal-on");
				// jQuery(".modal-contents input").focus();
			} else {
				jQuery("body").removeClass("modal-on");
			}
		},
	},
	methods: {
		closeModal: function () {
			this.modal.on = false;
			this.modal.type = null;
		},
		launchModal: function (modalType) {
			this.modal.on = true;
			this.modal.type = modalType;
			if (modalType === "register") {
			}
		},
	},
});

function updateIG() {
	if (typeof igArray !== "undefined") {
		var randImg = Math.floor(Math.random() * igArray.length);
		$(".ig-img").html('<img src="' + igArray[randImg] + '" border="0" />');
	}
}
updateIG();

$(".page-anchor").on("click", function (e) {
	e.preventDefault();
	var thisTarget = $(this).data("target");
	if ($(".section-" + thisTarget).hasClass("section-" + thisTarget)) {
		var newScrollTarget = $(".section-" + thisTarget).offset().top - 20;
		$("html,body").animate({ scrollTop: newScrollTarget }, 800);
	}
});

// });

var subOn = false;
var subActive = null;
$(".menu-item-has-children > a").on("click", function (e) {
	e.preventDefault();
	var targetID = $(this).parent().attr("id");
	if (subOn) {
		if (targetID === subActive) {
			subActive = null;
			subOn = false;
			$(".subnav-on").removeClass("subnav-on");
			$(".sub-on").removeClass("sub-on");
		} else {
			subActive = targetID;
			$("#pageheader").addClass("subnav-on");
			$(".sub-on").removeClass("sub-on");
			$(this).parent().addClass("sub-on");
		}
	} else {
		subActive = targetID;
		subOn = true;
		$("#pageheader").addClass("subnav-on");
		$(".sub-on").removeClass("sub-on");
		$(this).parent().addClass("sub-on");
	}
});
$(".sub-close, .sub-menu a").on("click", function () {
	subActive = null;
	subOn = false;
	$(".subnav-on").removeClass("subnav-on");
	$(".sub-on").removeClass("sub-on");
});

if ($(".gallery-container").hasClass("gallery-container")) {
	$(".gallery-container").flickity({
		cellAlign: "center",
		contain: true,
		setGallerySize: false,
		cellSelector: ".gallery-image-single",
		imagesLoaded: true,
		wrapAround: true,
		arrowShape:
			"M98.2,45H14.3l32.2,32.2l-5.3,5.2L0,41.2L41.2,0l5.4,5.2L14.3,37.4h83.9V45z",
	});
}

if ($(".guidecollections").hasClass("guidecollections")) {
	let customStart = 0;
	if ($(".guidecollections").hasClass("randomize-order")) {
		customStart = Math.floor(Math.random() * $(".guidecollection").length);
	}
	$(".guidecollections").flickity({
		cellAlign: "center",
		contain: true,
		setGallerySize: true,
		cellSelector: ".guidecollection",
		imagesLoaded: true,
		initialIndex: customStart,
		pageDots: false,
		wrapAround: true,
		arrowShape:
			"M98.2,45H14.3l32.2,32.2l-5.3,5.2L0,41.2L41.2,0l5.4,5.2L14.3,37.4h83.9V45z",
	});
}
if ($(".member-highlight-cycle").hasClass("member-highlight-cycle")) {
	$(".member-highlight-cycle").flickity({
		cellAlign: "center",
		contain: true,
		setGallerySize: true,
		cellSelector: ".guide-testimonial-single",
		imagesLoaded: true,
		pageDots: false,
		wrapAround: true,
		arrowShape:
			"M98.2,45H14.3l32.2,32.2l-5.3,5.2L0,41.2L41.2,0l5.4,5.2L14.3,37.4h83.9V45z",
	});
}

if ($(".card-carousel").hasClass("card-carousel")) {
	$(".card-carousel").each(function () {
		var cardLength = $(this).find(".card").length;
		var wrapTF = false;
		var cellAlign = "left";
		var autoSize = false;
		if ($(this).hasClass("guide-cards")) {
			autoSize = true;
		}
		if (cardLength > 5) {
			wrapTF = true;
			cellAlign = "center";
		}
		$(this).flickity({
			cellAlign: cellAlign,
			contain: false,
			setGallerySize: autoSize,
			cellSelector: ".card",
			imagesLoaded: true,
			pageDots: false,
			wrapAround: wrapTF,
			arrowShape:
				"M98.2,45H14.3l32.2,32.2l-5.3,5.2L0,41.2L41.2,0l5.4,5.2L14.3,37.4h83.9V45z",
		});
	});
}

if ($(".redemption-modal").hasClass("redemption-modal")) {
	$("button.cta-launch").on("click", function () {
		$("body").addClass("modal-on");
	});
	$(".modal-close,.modal-bg").on("click", function () {
		$("body").removeClass("modal-on");
	});
}
$(".user-menu-bg").on("click", function () {
	$(".menu-open").removeClass("menu-open");
});

$(".toggleMenu").on("click", function (e) {
	e.preventDefault();
	$(this).parent().toggleClass("menu-open");
});

$(".menu-toggle").on("click", function () {
	$("body").toggleClass("menu-on");
});

var scrollTrigger = false;
var pageNum = 1;
var filterDiscipline = "";
var filterLocation = "";
var filterByType = "";
var filterByYear = "";
var inviewPreload = null;

inView(".ivPreload").on("enter", function (el) {
	if (!$(el).hasClass(".iv-preloaded")) {
		var tempSrc = $(el).data("src");
		$(el).attr("src", tempSrc);
		$(el).addClass("iv-preloaded");
	}
});

var ajMemberFormSubmit = function (clear) {
	$("#members-dir-list").addClass("loading");
	if ($("#members_search").val() !== "") {
		$("#members-directory-form").addClass("has-search-el");
	} else {
		$("#members-directory-form").removeClass("has-search-el");
	}
	var scopeThis = this;
	var letter = "";
	var clearQuery = false;
	if (clear) {
		clearQuery = true;
	}

	if ($(".letter-active")) {
		letter = $(".letter-active a").html();
	}

	jQuery.post(
		ajaxurl,
		{
			action: "members_ajax",
			data: $("#members_search").val(),
			orderby: $("#members-order-by").val(),
			clear: clearQuery,
			sortLetter: letter,
			pageNum: pageNum,
			locationFilter: filterLocation,
			disciplineFilter: filterDiscipline,
		},
		function (response) {
			if (response.slice(-1) == "0") {
				response = response.slice(0, -1);
			}
			if (response == "False") {
				$("#members-dir-list").html(
					"<p class='tac'>No members found.</p>"
				);
			} else {
				$("#members-dir-list").html(response);
			}
			$("#members-dir-list").removeClass("loading");

			setTimeout(function () {
				inView(".ivPreload").on("enter", function (el) {
					if (!$(el).hasClass(".iv-preloaded")) {
						var tempSrc = $(el).data("src");
						$(el).attr("src", tempSrc);
						$(el).addClass("iv-preloaded");
						// $(window).trigger("scroll");
					}
				});
				inView(".ivPreload").check();
			}, 500);
			// scopeThis.rerouteLinks();
			// chipsAJCB();
		}
	);
};

var resetMembersSearch = function () {
	filterDiscipline = "";
	filterLocation = "";
	$.each($(".chips-filter"), function () {
		$(this).addClass("clean");
		var defaultText = $(this).data("default");
		$(this).find("p .active-text").html(defaultText);
	});
	$.each($(".display-filter"), function () {
		// console.log($(this));
		$(this).addClass("clean");
		var defaultText = $(this).data("default");
		$(this).html(defaultText);
	});
};

var ajResourceGrid = function (pageNum) {
	$(".resources-wrap").addClass("loading");

	jQuery.post(
		ajaxurl,
		{
			action: "resources_ajax",
			pageNum: pageNum,
			byYear: filterByYear,
			byType: filterByType,
		},
		function (response) {
			if (response.slice(-1) == "0") {
				response = response.slice(0, -1);
			}

			$(".resources-wrap").html(response);
			$("html,body").animate({ scrollTop: 0 }, 500);
			// }
			$(".resources-wrap").removeClass("loading");
			$(".addHov").hover(
				function () {
					$(this).addClass("hovered");
				},
				function () {
					$(this).removeClass("hovered");
				}
			);

			$(".addHovParent").hover(
				function () {
					$(this).parent().addClass("hovered");
				},
				function () {
					$(this).parent().removeClass("hovered");
				}
			);
			// scopeThis.rerouteLinks();
			// chipsAJCB();
		}
	);
};

$(".hovParent a").hover(
	function () {
		$(this).closest(".hovParent").addClass("hovered");
	},
	function () {
		$(this).closest(".hovParent").removeClass("hovered");
	}
);

$("body").on("click", "#reset-members", function (e) {
	e.preventDefault();
	resetMembersSearch();
	pageNum = 1;
	$("#members-order-by").val("active");
	$("#members_search").val("");
	ajMemberFormSubmit(true);
});

$("body").on("click", ".letter-nav a", function (e) {
	e.preventDefault();
	e.stopPropagation();
	pageNum = 1;
	resetMembersSearch();
	$("#members_search").val("");
	$(".letter-active").removeClass("letter-active");
	$(this).parent().addClass("letter-active");
	ajMemberFormSubmit();
});

$("body").on("keyup", "#members_search", function (event) {
	if (
		event.which == "13" ||
		event.which == "16" ||
		event.which == "20" ||
		event.which == "17" ||
		event.which == "18" ||
		event.which == "37" ||
		event.which == "38" ||
		event.which == "39" ||
		event.which == "40"
	) {
	} else {
		pageNum = 1;
		$(".letter-active").removeClass("letter-active");
		resetMembersSearch();
		ajMemberFormSubmit();
	}
});

$("body").on("click", "#member-dir-pag-bottom .page-numbers", function (e) {
	e.preventDefault();
	e.stopPropagation();
	if (!$(this).hasClass("dots")) {
		if ($(this).hasClass("next")) {
			pageNum = parseInt(pageNum) + 1;
		} else if ($(this).hasClass("prev")) {
			pageNum = parseInt(pageNum) - 1;
		} else {
			pageNum = $(this).html();
		}

		$("#member-dir-pag-bottom .page-numbers").removeClass("current");
		$(this).addClass("current");
		$("html,body").animate({ scrollTop: 0 }, 0, function (e) {});
		ajMemberFormSubmit();
	}
});

$("body").on("click", ".resources-pagination .page-numbers", function (e) {
	e.preventDefault();
	e.stopPropagation();
	var pageNum = $(this).data("page");
	ajResourceGrid(pageNum);
});

$("body").on("click", "#members_search_submit", function (e) {
	e.preventDefault();
	$(".letter-active").removeClass("letter-active");
	resetMembersSearch();
	pageNum = 1;
	ajMemberFormSubmit();
});

$("body").on("submit", "#members-directory-form", function (e) {
	e.stopPropagation();
	e.preventDefault();
	pageNum = 1;
	resetMembersSearch();
	$(".letter-active").removeClass("letter-active");
	ajMemberFormSubmit();
});

$("body").on("change", "#members-order-by", function (e) {
	e.preventDefault();
	pageNum = 1;
	ajMemberFormSubmit();
});

if ($(".partner-list").hasClass("partner-list")) {
	var rotateHero = new RotateEls(
		".partner-list",
		".partners-group",
		".gNavIndex",
		".hero-nav li",
		1,
		false
	);
	rotateHero.startTimer(8000);
}

$("body").on("click", ".load-more-toggle", function (e) {
	$(".grid-col-events").removeClass("hidden");
	$(this).hide();
});
$("body").on("click", ".chips-filter p", function (e) {
	e.stopPropagation();
	if ($(this).parent().hasClass("expand")) {
		$(".chips-filter").removeClass("expand");
		$(this).parent().removeClass("expand");
		$("body").removeClass("dropdownOn");
	} else {
		$(".chips-filter").removeClass("expand");
		$(this).parent().addClass("expand");
		$("body").addClass("dropdownOn");
	}
});
$("body").on("click", ".chips-filter li", function (e) {
	$(".load-more-toggle").hide();
	$(".grid-col-events").removeClass("hidden");
	$("body").removeClass("dropdownOn");
	$(".grid-col-events:not([data-year='" + $(this).html() + "'])").addClass(
		"hidden"
	);
	var parentFilter = $(this).parent().parent();
	if ($(this).data("value") == "all") {
		parentFilter.find("p .active-text").html($(this).data("fieldName"));
	} else {
		parentFilter.removeClass("clean");
		parentFilter.find("p .active-text").html($(this).html());
	}

	parentFilter.removeClass("expand");
	parentFilter.find("li").removeClass("selected");
	$(this).addClass("selected");
});

$("body").on("click", ".members-filters li", function (e) {
	var fieldName = $(this).data("fieldName");
	if (fieldName == "Discipline") {
		filterLocation = "";
		$(".chips-filter[data-default='Location']").addClass("clean");
		$(".chips-filter[data-default='Location']")
			.find(".active-text")
			.html("Location");

		if ($(this).data("value") == "all") {
			filterDiscipline = "";
			$(".chips-filter[data-default='" + fieldName + "']").addClass(
				"clean"
			);
		} else {
			filterDiscipline = $(this).data("value");
			$(".chips-filter[data-default='" + fieldName + "']").removeClass(
				"clean"
			);
		}
	} else if (fieldName == "Location") {
		filterDiscipline = "";
		$(".chips-filter[data-default='Discipline']").addClass("clean");
		$(".chips-filter[data-default='Discipline']")
			.find(".active-text")
			.html("Discipline");

		if ($(this).data("value") == "all") {
			filterLocation = "";
			$(".chips-filter[data-default='" + fieldName + "']").addClass(
				"clean"
			);
		} else {
			filterLocation = $(this).data("value");
			$(".chips-filter[data-default='" + fieldName + "']").removeClass(
				"clean"
			);
		}
	} else if (fieldName == "By Type") {
		if ($(this).data("value") == "all") {
			filterByType = "";
			$(".chips-filter[data-default='" + fieldName + "']").addClass(
				"clean"
			);
		} else {
			filterByType = $(this).data("value");
			$(".chips-filter[data-default='" + fieldName + "']").removeClass(
				"clean"
			);
		}
	} else if (fieldName == "By Year") {
		if ($(this).data("value") == "all") {
			filterByYear = "";
			$(".chips-filter[data-default='" + fieldName + "']").addClass(
				"clean"
			);
		} else {
			filterByYear = $(this).data("value");
			$(".chips-filter[data-default='" + fieldName + "']").removeClass(
				"clean"
			);
		}
	}

	if (fieldName == "Discipline" || fieldName == "Location") {
		pageNum = 1;
		$("#members_search").val("");
		$(".letter-active").removeClass("letter-active");
		ajMemberFormSubmit();
	} else {
		ajResourceGrid(1);
	}
});

$("body").on("change", ".select-filter", function (e) {
	var fieldName = $(this).data("fieldName");
	$(this).parent().find(".display-filter").removeClass("clean");
	if ($(this).val() == "") {
		$(this).parent().find(".display-filter").addClass("clean");
		$(this).parent().find(".display-filter").html(fieldName);
	} else {
		$(this).parent().find(".display-filter").html($(this).val());
	}

	if (fieldName == "Discipline") {
		filterLocation = "";
		$(".select-filter[data-field-name='Location']")
			.parent()
			.find(".display-filter")
			.addClass("clean");
		$(".select-filter[data-field-name='Location']")
			.parent()
			.find(".display-filter")
			.html("Location");
		if ($(this).val() == "") {
			filterDiscipline = "";
		} else {
			filterDiscipline = $(this).val();
		}
	} else if (fieldName == "Location") {
		filterDiscipline = "";
		$(".select-filter[data-field-name='Discipline']")
			.parent()
			.find(".display-filter")
			.addClass("clean");
		$(".select-filter[data-field-name='Discipline']")
			.parent()
			.find(".display-filter")
			.html("Discipline");
		if ($(this).val() == "") {
			filterLocation = "";
		} else {
			filterLocation = $(this).val();
		}
	} else if (fieldName == "By Type") {
		if ($(this).val() == "all") {
			filterByType = "";
		} else {
			filterByType = $(this).val();
		}
	} else if (fieldName == "By Year") {
		if ($(this).val() == "all") {
			filterByYear = "";
		} else {
			filterByYear = $(this).val();
		}
	}

	if (fieldName == "Discipline" || fieldName == "Location") {
		pageNum = 1;
		$("#members_search").val("");
		$(".letter-active").removeClass("letter-active");
		ajMemberFormSubmit();
	} else {
		ajResourceGrid(1);
	}
	// if ($(this).data("value") == "all") {
	// filterDiscipline = $(this).data("value");
});

$("body").on("change", ".select-filter-events", function (e) {
	$(".load-more-toggle").hide();
	$(".grid-col-events").removeClass("hidden");

	var parentFilter = $(this).parent().parent();
	$(this).parent().find(".display-filter").removeClass("clean");
	if ($(this).val() == "") {
		$(".grid-col-events").removeClass("hidden");
		$(this).parent().find(".display-filter").addClass("clean");
		$(this).parent().find(".display-filter").html("Filter By Year");
	} else {
		$(".grid-col-events:not([data-year='" + $(this).val() + "'])").addClass(
			"hidden"
		);
		parentFilter.removeClass("clean");
		$(this).parent().find(".display-filter").html($(this).val());
	}
});

$(window).click(function () {
	$(".chips-filter").removeClass("expand");
	$(".chips-select-wrap").removeClass("expanded");
});

if ($("#gform_wrapper_7").hasClass("gform_wrapper")) {
	$("#gform_wrapper_7 textarea").each(function () {
		$(this).addClass("autosize");
		autoresize(this);
	});

	$(".autosize").keyup(function () {
		autoresize(this);
	});
} else if ($("#gform_wrapper_8").hasClass("gform_wrapper")) {
	$("#gform_wrapper_8 textarea").each(function () {
		$(this).addClass("autosize");
		autoresize(this);
	});

	$(".autosize").keyup(function () {
		autoresize(this);
	});
} else if ($("#gform_wrapper_9").hasClass("gform_wrapper")) {
	$("#gform_wrapper_9 textarea").each(function () {
		$(this).addClass("autosize");
		autoresize(this);
	});

	$(".autosize").keyup(function () {
		autoresize(this);
	});
} else if ($(".guideformwrapper").parent().hasClass("gform_wrapper")) {
	$(".guideformwrapper textarea").each(function () {
		$(this).addClass("autosize");
		autoresize(this);
	});

	$(".autosize").keyup(function () {
		autoresize(this);
	});
}

function autoresize(textarea) {
	textarea.style.height = "20px";
	textarea.style.height = textarea.scrollHeight + "px";
}

$("#gform_9 .gfield, .guideformwrapper .gfield").each(function () {
	if (
		!$(this).hasClass("gform_hidden") &&
		!$(this).hasClass("gsection") &&
		!$(this).hasClass("gfield_html_formatted")
	) {
		$(this).append(
			'<div class="form-actions"><button class="skip">Skip</button><button class="next">Next</button</div>'
		);
	}
});
$(".form-actions button").on("click", function (e) {
	e.preventDefault();
	var parEl = $(this).closest(".gfield");
	activeNextEl(parEl);
});

function activeNextEl(parEl, firstItem) {
	var winH = $(window).height();
	if (parEl.next(".gfield:not(.gsection):not(.gform_hidden)")) {
		var newOffset = parEl.next(".gfield").offset().top - 50;
		var newH = parEl.next(".gfield").innerHeight();
		// if (firstItem) {
		// 	newH =
		// 		parEl
		// 			.next(".gfield")
		// 			.next(".gfield")
		// 			.next(".gfield")
		// 			.innerHeight() + 100;
		// } else {
		if (
			parEl
				.next(".gfield:not(.gsection):not(.gform_hidden)")
				.find("textarea")
				.hasClass("textarea")
		) {
			// newH = parEl.next(".gfield").innerHeight();
		} else {
			newH = parEl.next(".gfield").next(".gfield").innerHeight() + 100;
		}
		// }
		if (winH > 500) {
			if (newH < winH) {
				newOffset = newOffset - winH * 0.5 + newH;
			}
		}
		if (newOffset && newOffset > 0) {
			// $("html,body").animate({ scrollTop: newOffset }, 800);
			window.scrollTo(0, newOffset);
			setTimeout(function () {
				if (
					parEl
						.next(".gfield:not(.gsection):not(.gform_hidden)")
						.find("textarea")
						.hasClass("textarea")
				) {
					parEl
						.next(".gfield:not(.gsection):not(.gform_hidden)")
						.find("input,textarea")
						.eq(0)
						.focus();
				} else {
					parEl
						.next(".gfield")
						.next(".gfield")
						.find("textarea")
						.eq(0)
						.focus();
				}
			}, 300);
		}
	}
}
$("#gform_9 .gfield textarea, .guideformwrapper .gfield textarea").on(
	"keydown",
	function (e) {
		//console.log();
		if (e.keyCode === 13) {
			var parEl = $(this).closest(".gfield");
			if (
				parEl.find(".gfield_description").hasClass("gfield_description")
			) {
			} else {
				e.preventDefault();
				activeNextEl(parEl, null);
			}
		}
		var newVal = $(this).val();
		if (newVal.length >= 3) {
			$(this).closest(".gfield").addClass("has-value");
		} else {
			$(this).closest(".gfield").removeClass("has-value");
		}
	}
);

$(".start-form").on("click", function (e) {
	e.preventDefault();

	var firstEl = $(".gform_wrapper .gfield textarea")
		.eq(0)
		.closest(".gfield")
		.prev(".gfield");
	activeNextEl(firstEl, true);
	// var newOffset = firstEl.closest(".gfield").offset().top - 100;
	// window.scrollTo(0, newOffset);
	// firstEl.focus();
});

inView(".js #gform_9 .gfield, .js .guideformwrapper .gfield").on(
	"enter",
	function (el) {
		$(el).addClass("form-in");
	}
);
